
import { Component, Mixins } from "vue-property-decorator";
import { userApi } from "@/api/UserApi";
import Dialog from "@/components/ui/Dialog.vue";
import { AuthMixin, BAIconsMixin } from '@/mixins';

@Component({
	components: {
		Dialog
	}
})
export default class AccountSettingsChangePassword extends Mixins(AuthMixin, BAIconsMixin) {

	currentPasswordShow: boolean = false;
	newPasswordShow: boolean = false;

	loading = true;

	async created(): Promise<void> {
		this.loading = false;
	}

	currentPassword: "";
	newPassword: "";
	newPasswordConfirm: "";

	saveLoading: boolean = false;
	submitValid: boolean | null = null;

	twoFactorHelpDialog: boolean = false;

	passwordRequestEmailLoading: boolean = false;

	async onSave(validate: () => Promise<boolean>, reset: () => Promise<void>): Promise<void> {
		const isValid = await validate();

		if (isValid) {
			this.saveLoading = true;
			const valid = await userApi.changePassword(
				this.currentPassword,
				this.newPassword
			);
			this.submitValid = valid;
			this.saveLoading = false;

			if (valid) {
				this.onCancel();
				reset();
				this.submitValid = true
				setTimeout(() => {
					this.submitValid = null
				}, 7000);
			}
		}
	}
	async requestPasswordEmail(): Promise<void> {
		this.passwordRequestEmailLoading = true;
		await userApi.requestPasswordEmail();

		setTimeout(() => this.passwordRequestEmailLoading = false, 3000)
	}

	async onCancel(): Promise<void> {
		this.currentPassword = "";
		this.newPassword = "";
		this.newPasswordConfirm = "";
		this.$emit("cancel");
	}

	async currentPasswordChanged(): Promise<void> {
		this.submitValid = null;
	}

	get passwordChangeFlag(): "email" | "setting" | "disabled" {
		return 'email';
	}
}
